import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { UtilsService } from '../../Services/utils.service';
import { NgIf } from '@angular/common';
import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { ApiCallService } from '../../Services/api-call-service.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-footer',
  imports: [FontAwesomeModule, NgIf, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnDestroy {
  isChatVisible: boolean = false;
  constructor(
    private router: Router,
    private _utils: UtilsService,
    private apiCallService: ApiCallService,
    private cdr: ChangeDetectorRef
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check for token and get chat count on each route change
        if (this.token) {
          this.getChatCount();
        }
      }
    });
    this._utils.showComponent$.pipe(takeUntil(this.destroy$)).subscribe((visible: boolean) => {
      this.isChatVisible = visible;
      console.log('this.isChatVisible', this.isChatVisible);
      // if (!visible && this.token) {
      //   this.getChatCount();
      // }
    });
  }
  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  facebook = faFacebook;
  twitter = faTwitter;
  @Input() chatUnreadCount: number = 0;
  get token(): string | null {
    // if (this.isBrowser) {
    const token = localStorage.getItem('token');
    return token;
    // }
    // return '';
  }
  ngOnInit() {
    // if (this.token) {
    //   this.getChatCount();
    // }
    // const token = this._utils.getItem('token');
    // if (token && token !== '') {
    //   this.getChatCount();
    // }
    this._utils
      .getTriggerChatUnReadCountObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getChatCount();
      });
  }
  unreadCounts: number = 0;
  Wallet = faWallet;
  async getChatCount() {
    this.cdr.detectChanges();
    this.cdr.markForCheck();
    try {
      await this.apiCallService
        .GetCallWithToken('NotificationMessages/GetUnReadChatMessages')
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            if (response.responseCode === 200) {
              this.cdr.detectChanges();
              this.cdr.markForCheck();
              this.unreadCounts = response.data[0].UnreadCount;
            }
          },
          error: (error) => {
            // this.apiCallService.handleError(error);
          },
        });
    } catch (error: any) {
      // this.apiCallService.handleError(error);
    }
  }
  RedirectDashboard() {
    if (localStorage.getItem('token')) {
      this.router.navigate(['/dashboard/home']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  hideChatComponentAndRedirection() {
    this._utils.toggleComponentVisibility(false);
    // this._utils.showComponentSubject.next(false);
    // this._utils.showComponentSubject.closed = false;
    this._utils.triggerChatReadFunction();
  }
  RedirectSignup() {
    this.router.navigate(['/SignUp']);
  }

  // * Router navigation function
  changeRoute(path: string) {
    this._utils.toggleComponentVisibility(false);
    // this._utils.showComponent$.emit(false);
    this.router.navigate([path]);
    // this._utils.toggleComponentVisibility(false);
  }

  showChatComponent() {
    this._utils.toggleComponentVisibility(true);
  }
  isDashboardRoute(): boolean {
    // if (localStorage.getItem('token')) {
    return this.router.url.includes('dashboard');
    // }
  }
  isScreenWidthLessThan800(): boolean {
    return window.innerWidth < 800;
  }
  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return current === '/dashboard/treasure-pick' || current === '/dashboard/stack-builder' || current === '/dashboard/chickenroad' || current === '/dashboard/ace-win' || current === '/dashboard/card-brag-3' || current === '/dashboard/lucky-trigger' || current === '/dashboard/sum-dice' || current === '/dashboard/cashbull' || current === '/dashboard/slot-777' || current === '/dashboard/joker-777' || current === '/dashboard/space-hunt' || current === '/dashboard/aviator' || current === '/dashboard/StackBuilder' || current === '/dashboard/baccarat' || current === '/dashboard/roulette' || current === '/dashboard/mines' || current === '/dashboard/plinko' || current === '/dashboard/keno' || current === '/dashboard/double' || current === '/dashboard/toss' || current === '/dashboard/slots';
  }
}
